import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitString'
})
export class SplitStringPipe implements PipeTransform
{

  public transform(value: string, splitBy: string, position: number): string
  {
    return value.split(splitBy)[position];
  }

}
